(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["distrionline-accesos"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (customElements.get('distrionline-access')) return;
    class DistrionlineAccess extends HTMLElement {
      connectedCallback() {
        this.abort?.abort();
        this.observer?.disconnect();
        this.abort = new AbortController();
        const signal = this.abort.signal;
        this.groups = Array.from(this.querySelectorAll('[data-group]'));
        this.update = () => this.groups.forEach((group) => {
          const rail = group.querySelector('[data-rail]');
          const controls = group.querySelector('[data-controls]');
          const max = rail.scrollWidth - rail.clientWidth;
          const position = Math.abs(rail.scrollLeft);
          controls.hidden = max < 4;
          group.querySelector('[data-direction="-1"]').disabled = position < 4;
          group.querySelector('[data-direction="1"]').disabled = position >= max - 4;
        });
        this.groups.forEach((group) => {
          const rail = group.querySelector('[data-rail]');
          rail.addEventListener('scroll', this.update, { passive: true, signal });
          rail.addEventListener('keydown', (event) => {
            if (event.target !== rail || !['ArrowLeft', 'ArrowRight'].includes(event.key)) return;
            if (rail.scrollWidth - rail.clientWidth < 4) return;
            event.preventDefault();
            rail.scrollBy({ left: (event.key === 'ArrowRight' ? 1 : -1) * rail.clientWidth * .85, behavior: this.scrollBehavior() });
          }, { signal });
        });
        this.addEventListener('click', (event) => this.handleClick(event), { signal });
        this.addEventListener('auxclick', (event) => { if (event.button === 1) this.recordClick(event); }, { signal });
        this.addEventListener('load', this.update, { capture: true, signal });
        window.addEventListener('resize', this.update, { passive: true, signal });
        if (window.ResizeObserver) {
          this.observer = new ResizeObserver(this.update);
          this.groups.forEach((group) => this.observer.observe(group.querySelector('[data-rail]')));
        }
        if (this.dataset.editor === 'true') {
          document.addEventListener('shopify:block:select', (event) => {
            const item = Array.from(this.querySelectorAll('[data-block-id]')).find((node) => node.dataset.blockId === event.detail?.blockId);
            item?.scrollIntoView({ block: 'nearest', inline: 'center', behavior: 'auto' });
          }, { signal });
        }
        this.update();
        if (this.dataset.analytics === 'true' && this.dataset.editor !== 'true') this.loadPrivacy();
      }
      disconnectedCallback() { this.abort?.abort(); this.observer?.disconnect(); }
      scrollBehavior() { return window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'; }
      handleClick(event) {
        const control = event.target.closest('button[data-direction]');
        if (control && this.contains(control)) {
          const rail = control.closest('[data-group]').querySelector('[data-rail]');
          const rtl = getComputedStyle(rail).direction === 'rtl' ? -1 : 1;
          rail.scrollBy({ left: Number(control.dataset.direction) * rtl * rail.clientWidth * .85, behavior: this.scrollBehavior() });
          return;
        }
        this.recordClick(event);
      }
      loadPrivacy() {
        if (window.Shopify?.customerPrivacy || !window.Shopify?.loadFeatures || DistrionlineAccess.privacyRequested) return;
        DistrionlineAccess.privacyRequested = true;
        try {
          window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], (error) => {
            if (error) DistrionlineAccess.privacyRequested = false;
          });
        } catch (_) { DistrionlineAccess.privacyRequested = false; }
      }
      recordClick(event) {
        if (this.dataset.analytics !== 'true' || this.dataset.editor === 'true' || window.Shopify?.designMode) return;
        const link = event.target.closest('a[data-access-type]');
        if (!link || !this.contains(link)) return;
        try {
          // Leer el permiso en cada clic respeta aceptación y revocación posteriores.
          if (window.Shopify?.customerPrivacy?.analyticsProcessingAllowed?.() !== true) return;
          const detail = {
            event: 'distrionline_access_click',
            section_id: this.dataset.sectionId,
            access_type: link.dataset.accessType,
            item_id: link.dataset.itemId,
            item_name: link.dataset.itemName,
            position: Number(link.dataset.position)
          };
          // Solo prepara un evento para una integración existente. No instala GA4/GTM.
          if (Array.isArray(window.dataLayer)) window.dataLayer.push({ ...detail });
          this.dispatchEvent(new CustomEvent('distrionline_access_click', { bubbles: true, detail }));
        } catch (_) { /* La navegación funciona aunque falle la analítica. */ }
      }
    }
    customElements.define('distrionline-access', DistrionlineAccess);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
